var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-container',{staticClass:"elearning",attrs:{"title":_vm.$t('E-Learning'),"cover":""}})}
var staticRenderFns = []

export { render, staticRenderFns }